import { commonRequest } from '@/common/utils/request'
import { getLoginShopid, getWebId } from '@RootCommon/utils'

// 订单触达上报
export function reportTouch (params: { orderId?: string; ackChannelType?: number; shopId?: number | string }) {
  try {
    return commonRequest.post(
      '/api/order/touch',
      {
        shopId: params.shopId,
        pushToken: window.Owl?.cfgManager.getExtension('unionId'),
        ...params,
      },
      {
        autoToast: false,
        headers: {
          deviceType: window.Owl?.cfgManager.getExtension('unionId'),
        },
      },
    ) as Promise<string>
  } catch (e) {
    console.log(e)
  }
}

// 订单指纹上报
export function reportOrder (params: {
  orderViewIds?: string | string[] | number[] | undefined[]
  orderViewId?: string
  nodeName?: string
  midName?: string
  shopId?: number | string
  extraReq?: string
}) {
  try {
    return commonRequest.post(
      '/api/order/fingerprint/report',
      {
        shopId: params.shopId,
        // @ts-ignore
        pushToken: window.Owl?.cfgManager.getExtension('unionId'),

        ...params,
      },
      {
        autoToast: false,
        headers: {
          // @ts-ignore
          deviceType: window.Owl?.cfgManager.getExtension('unionId'),
        },
      },
    ) as Promise<string>
  } catch (e) {
    console.log(e)
  }
}

// 订单小票信息
export function getOrderReceiptPrintInfo (params: { templateType: number; orderViewId: number; shopId: number | string; receiptTemplateType?: number }, headers: { [key: string]: string } = {}) {
  try {
    return commonRequest.post(
      '/api/order/getOrderReceiptPrintInfo',
      {
        ...params,
        printType: 0, // 手动打印
      },
      { autoToast: false, needRetry: true, headers },
    ) as Promise<string>
  } catch (e) {
    console.log(e)
  }
}

// 获取订单详情
export function getOrderDtlApi (params: { viewId: number | string; shopId: number | string }, headers: { [key: string]: string } = {}) {
  try {
    return commonRequest.post('/api/order/getOrderDtl', params, { autoToast: false, headers }) as Promise<{ orderInfo: any }>
  } catch (e) {
    console.log(e)
  }
}

// 上报店家营业状态
// merchantStatus 0：未营业 1：营业
export function merchantReportMerchantStatus (params: { orderViewId: string | number; merchantSubOrderId?: string | number; isOpen: number; waybillId: string | number }) {
  try {
    return commonRequest.post(
      '/api/order/merchantReportMerchantStatus',
      {
        ...params,
        sessionId: `${Math.random()}`,
        merchantStatus: params.isOpen ? 1 : 0,
      },
      { autoToast: false },
    ) as Promise<string>
  } catch (e) {
    console.log(e)
  }
}

// 查询当前设备自动接单设置
export function getConfirmOrderConfig (params: { shopId: number | string; deviceDimension?: boolean }) {
  try {
    return commonRequest.post('/api/order/getConfirmOrderConfig', params, {
      autoToast: false,
      headers: {
        uuid: getWebId(),
      },
    })
  } catch (e) {
    console.log(e)
  }
}
